import axios from './axiosInterceptors';

const API_URL = "/api/v1/";

const getRoles = () => {
    return axios.get(API_URL + `rolemaster/Roles`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const saveRole = (role) => {
    return axios
        .post(API_URL + "rolemaster/SaveRole", role).then((response) => {
                return response.data;
            });
};
const deleteRole = (role) => {
    return axios
        .delete(API_URL + `rolemaster/DeleteRole/${role.rolId}`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => console.log("AXIOS ERROR: ", err))
};

const allActions = {
    getRoles,
    deleteRole,
    saveRole
};

export default allActions;